var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTw(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    width: 54,
    height: 40,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M.7 0h60v40H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000095",
    d: "M.7 0h30v20H.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.5 10.6-.2.8.8.2-.2-.6zm4 .4-.2.6.7-.2-.2-.8zm-3.6-2-.4.4.2.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.7 10-.2.6.4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.5 9.4-.6.6.6.6.2-.6zm1.2 2.3.4.5.6-.2zm1.5.5.8.2.3-.8-.6.1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.7 11.7.6-.1.1-.6zm-2.6-.1.2.8.8-.2-.4-.5zm1.6.4.5.2.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15 12.2.7.5.5-.5-.5-.2zm-1-3.8-.7.2.2.8.4-.4zm0 2.6v.6l.7.1zm3.7-1 .1-.6-.4-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m14.7 8.3-.6.1-.2.6zm2.7.7-.1-.6-.6-.1zm.4 1.6.6-.6-.6-.6-.1.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.4 9-.7-.7-1-.3-1 .3-.8.7-.2 1 .2 1 .8.7 1 .3 1-.3.7-.7.3-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.4 11 .4-.4-.1-.6zm.4-1.6.2-.8-.7-.2.1.6zm-.5-1-.3-.8-.8.2.5.5zM15 7.8l-.8-.2-.2.8.6-.1zm.6.2-.6-.2-.4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.2 7.8-.5-.5-.6.5.6.2zm.5.5-.5-.5-.5.2zM15 12.2l-.8.2.4 1.4 1-1zm-.4 1.6 1 3.7 1-3.7-1-1zm-.6-2.2-.8-.2-.4 1.3 1.4-.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13 12.7-1 3.8 2.7-2.7-.4-1.4zM12 11l-2.8 2.8 3.7-1 .4-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13.5 10.6-.6-.6-1 1 1.4.4zm0-1.2-.2-.8-1.4.4 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12 9-3.8 1 3.7 1 1-1zm7.4 2-1.4.4.4 1.3 3.8 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.3 11.6-.3.8 1.4.3-.4-1.3zm-1 .6-.6.5 1 1 .3-1.3zm1.5-1.6.2.8 1.4-.4-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.7 13.8 2.7 2.7-1-3.8-1.4-.3zm.6-5.4.7.2.4-1.3-1.4.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m19.4 9 2.8-2.7-3.8 1-.4 1.3zm-1-1.7 1-3.8-2.7 2.8.3 1.3zm1 3.7 3.8-1-3.8-1-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m17.8 9.4.6.6 1-1-1.4-.4zm-3.1-3.1-2.8-2.8 1 3.8 1.4.3zM14 8.4l.3-.8-1.4-.3.4 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m13 7.3-3.8-1L11.9 9l1.4-.4zm3.2.5.8-.2-.3-1.3-1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m16.7 6.3-1-3.8-1 3.8 1 1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m15 7.8.7-.5-1-1-.4 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000095",
    d: "M15.7 14.3a4.3 4.3 0 1 0 0-8.6 4.3 4.3 0 0 0 0 8.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.7 13.8a3.8 3.8 0 1 0 0-7.6 3.8 3.8 0 0 0 0 7.6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.7 0H54v40H.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTw);
export default __webpack_public_path__ + "static/media/tw.68ab5ab1384d7ce5eacd1713b7434c76.svg";
export { ForwardRef as ReactComponent };